export type LoginParamDecision =
  | { open: false }
  | { open: true; redirectTo?: string; reason?: LoginParamReason };

export type LoginParamReason = "expired";

// Rejects `//evil.com` too: a bare startsWith("/") would make `next` an open redirect.
export const isInAppPath = (value: string | null): value is string =>
  !!value && value.startsWith("/") && !value.startsWith("//");

export const decideLoginParam = (
  loginParam: string | null,
  next: string | null,
  hasSession: boolean,
): LoginParamDecision => {
  if (loginParam === null) return { open: false };
  if (hasSession) return { open: false };
  return {
    open: true,
    ...(isInAppPath(next) && { redirectTo: next }),
    ...(loginParam === "expired" && { reason: "expired" as const }),
  };
};
